<div class="ta-dialog">

  <!-- Header -->
  <div class="ta-header">
    <div class="ta-title-wrap">
      <div class="ta-title-icon">
        <mat-icon>{{isCopy ? 'content_copy' : 'design_services'}}</mat-icon>
      </div>
      <div class="ta-title-text">
        <h2 id="template_add_title" class="ta-title">{{dialogTitle}}</h2>
        <div class="ta-subtitle">{{dialogSubtitle}}</div>
      </div>
    </div>
    <button mat-icon-button mat-dialog-close class="ta-close" [disabled]="saveClicked" aria-label="Close">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <!-- Body -->
  <form id="addTemplate" class="ta-body" (ngSubmit)="saveClick()">

    @if (isCopy) {
      <div class="ta-field">
        <label class="ta-label">Copying from</label>
        <div class="ta-source">
          <mat-icon>description</mat-icon>
          <span class="ta-source-name">{{templateToCopy.name}}</span>
        </div>
      </div>
    }

    <div class="ta-field" [class.ta-field-last]="isCopy">
      <label class="ta-label">Template name <span class="ta-req">*</span></label>
      <mat-form-field appearance="outline" class="ta-mat full-width">
        <input id="template_add_name" matInput placeholder="Name this template" type="text" required name="name" [(ngModel)]="name">
      </mat-form-field>
    </div>

    @if (!isCopy) {
      <div class="ta-field ta-field-last">
        <label class="ta-label">Template type</label>
        <div class="ta-types">
          @for (type of templateTypes; track type.id) {
            <button type="button" class="ta-type"
              [class.on]="selectedTemplateType === type.id"
              (click)="selectedTemplateType = type.id">
              <mat-icon class="ta-type-icon">{{type.id === 'primary' ? 'local_florist' : 'account_tree'}}</mat-icon>
              <span class="ta-type-name">{{type.name | titlecase}}</span>
              <span class="ta-type-desc">
                {{type.id === 'primary' ? 'Full grow plan with phases, used to plan harvests' : 'Reusable task sequence for task groups'}}
              </span>
              <mat-icon class="ta-type-check">check_circle</mat-icon>
            </button>
          }
        </div>
      </div>
    }

  </form>

  <!-- Footer -->
  <div class="ta-footer">
    <div class="ta-footer-actions">
      <button mat-button mat-dialog-close class="ta-btn-ghost" [disabled]="saveClicked">Cancel</button>
      <button id="template_add_save" type="submit" form="addTemplate" class="ta-btn-primary" [disabled]="saveClicked">
        @if (saveClicked) {
          <mat-spinner diameter=20 strokeWidth=3></mat-spinner>
        } @else {
          <span>{{isCopy ? 'Copy template' : 'Create template'}}</span>
          <mat-icon>check</mat-icon>
        }
      </button>
    </div>
  </div>

</div>
